import React from 'react';
import EntityForm from './EntityForm';

function ManageBuyerForm({ onChanged, selectedEntry = null, setSelectedEntry }) {
    return (
        <EntityForm
            noun="Buyer"
            heading="Add New Buyer"
            idKey="BuyerID"
            insertUrl="insert_manage_buyer"
            updateUrl="update_manage_buyer"
            deleteUrl="delete_manage_buyer"
            fields={[
                { name: 'name', label: 'Name', entryKey: 'Name', required: true },
                { name: 'address', label: 'Address', entryKey: 'Address' },
                { name: 'contact', label: 'Contact No.', entryKey: 'ContactNo' },
            ]}
            selectedEntry={selectedEntry}
            setSelectedEntry={setSelectedEntry}
            onChanged={onChanged}
        />
    );
}

export default ManageBuyerForm;
